import { Chip } from '@mui/material';
import { ArrowForward } from '@mui/icons-material';
import { Button } from 'system/atoms';
import { usePathsV2 } from 'core/services/navigation/usePathsV2';
import { sourceExternallyButtonSx } from 'modules/sourcing-external/styles';

type SourceExternallyButtonProps = {
  candidateBatchId: string;
};

export const SourceExternallyButton: React.FC<SourceExternallyButtonProps> = ({
  candidateBatchId
}) => {
  const { navigateToPath } = usePathsV2();

  const handleClick = () => {
    navigateToPath.ANALYSE_SOURCE_EXTERNAL_CANDIDATES({ candidateBatchId });
  };

  return (
    <Button
      variant="tertiary"
      sx={sourceExternallyButtonSx.button}
      onClick={handleClick}
    >
      <ArrowForward />
      Source externally
      <Chip label="BETA" color="primary" variant="inverse" />
    </Button>
  );
};
